import { Button } from "primereact/button";

const SendButton = ({ onClick, label = "Actualizar Datos", disabled = null }) => {
  return (
    <div className="flex w-full h-16 justify-end">
      <Button
        disabled={disabled}
        label={label}
        className="flex !w-64 !h-6 bg-blue-800 text-white"
        onClick={onClick}
      />
    </div>
  );
};

export default SendButton;
